import { OnboardingPartnerState, OnboardingRootState } from "../reducers/rootReducer";
import { initialTicketingState } from "../reducers/ticketingReducer";

const emptyState = { ticketing: initialTicketingState } as OnboardingPartnerState;

export const getOnboardingState = (state: OnboardingRootState): OnboardingPartnerState =>
  state?.["publisher-onboarding"] ?? emptyState;
